/* 布局 */
//前台
import Layout from "@views/layout";

const schcourseschapterRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "schcourseschapter",
            name: "SCHCOURSESCHAPTER",
            meta: {
                title: "学校教材章节表",
                sort: 1,
            },
            component: () => import("@views/business/schcourseschapter/index.vue"),
            redirect: {
                name: "SCHCOURSESCHAPTER_LIST",
            },
            children: [
                {
                    path: "list/:sccou_id",
                    name: "SCHCOURSESCHAPTER_LIST",
                    meta: {
                        title: "学校教材章节表",
                        sort: 2,
                    },
                    component: () => import("@views/business/schcourseschapter/list.vue"),
                },
                {
                    path: "add/:refid",
                    name: "SCHCOURSESCHAPTER_ADD",
                    meta: {
                        title: "新增学校教材章节表",
                        parentPath: '/business/schcourseschapter/list',
                        operate: true,
                    },
                    component: () => import("@views/business/schcourseschapter/form.vue"),
                },
                {
                    path: "edit/:id",
                    name: "SCHCOURSESCHAPTER_EDIT",
                    meta: {
                        title: "编辑学校教材章节表",
                        parentPath: '/business/schcourseschapter/list',
                        operate: true,
                    },
                    component: () => import("@views/business/schcourseschapter/form.vue"),
                },
            ],
        },


    ],
};

export default schcourseschapterRouter;
